import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import NumberRangeThemePicker from 'core/numberRangeThemePicker';

export const InvertNumberColorLabelNumber = styled.div<{ $isInverted: boolean }>`
  display: inline-block;
  width: ${pxToRem(30)};
  height: ${pxToRem(30)};
  line-height: ${pxToRem(30)};
  text-align: center;
  margin: -${pxToRem(10)} ${pxToRem(10)} -${pxToRem(10)} 0;
  font-weight: 600;
  background: ${({ $isInverted }) => ($isInverted ? '#c3c3c5' : 'inherit')};
  color: ${({ $isInverted }) => ($isInverted ? '#fff' : 'inherit')};
`;

export const Label = styled.label`
  input.hidden + label {
    display: flex;
  }
`;

export const ColorPickerContainer = styled.div`
  display: flex;
`;

export const ColorLabel = styled.span`
  margin-left: ${pxToRem(5)};
`;

export const IconLabel = styled.span`
  margin-left: ${pxToRem(5)};
`;

export const IconContainer = styled.div<{ $isPositiveColor: boolean }>`
  display: inline-block;
  i {
    color: ${({ $isPositiveColor }) => ($isPositiveColor ? '#2cc36b' : '#d14233')};
  }
`;

export const StyledNumberRangeThemePicker = styled(NumberRangeThemePicker)`
  display: inline-block;
`;
